import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TeacherHistory {
  teacher_code: string;
  teacher_name: string | null;
  teacher_nickname: string | null;
  total_classes: number;
  total_hours: number;
  last_class_date: string;
}

export interface PurchaseHistory {
  amount: number;
  payment_date: string;
  type: 'renewal' | 'new';
}

export interface StudentTeacherHistoryResponse {
  student_code: string;
  student_name: string | null;
  student_nickname: string | null;
  teachers: TeacherHistory[];
  purchases: PurchaseHistory[];
}

export function useStudentTeacherHistory(studentCode: string | null) {
  return useQuery({
    queryKey: ["student-teacher-history", studentCode],
    queryFn: async (): Promise<StudentTeacherHistoryResponse> => {
      const { data, error } = await supabase.functions.invoke("get-student-teacher-history", {
        body: { studentCode },
      });

      if (error) {
        throw new Error(error.message);
      }

      return data as StudentTeacherHistoryResponse;
    },
    enabled: !!studentCode,
  });
}
